export const PRODUCTS_IDS = {};
